angular.module('aprima-provider-api').factory('MedicalDevicesRepository',
    ['AprimaRestangular',
        function(AprimaRestangular) {
            'use strict';

            function getMedicalDeviceParseUdi(uniqueDeviceId) {
                var searchCriteria = {
                    UniqueDeviceIdentifier : uniqueDeviceId
                };

                var restangular = AprimaRestangular.get();
                return restangular.one('history/medical-device/').customGET('parse-udi', searchCriteria);
            }

            function getMedicalDeviceLookup(deviceId, uniqueDeviceId) {
                var searchCriteria = {
                    DeviceIdentifier : deviceId,
                    UniqueDeviceIdentifier : uniqueDeviceId
                };

                var restangular = AprimaRestangular.get();
                return restangular.one('history/medical-device/').customGET('lookup', searchCriteria);
            }

            function getMedicalDevices(patientId, visitId) {
                var searchCriteria = {
                    PatientId : patientId,
                    VisitId : visitId
                };

                var restangular = AprimaRestangular.get();
                return restangular.one('history/medical-device/patient/').customGET(patientId + '/', searchCriteria);
            }

            function createMedicalDevice(createDeviceAttributes) {
                var restangular = AprimaRestangular.get();
                return restangular.all('history/medical-device/patient/' + createDeviceAttributes.PatientId + '/').post(createDeviceAttributes);
            }

            function updateMedicalDevice(updateDeviceAttributes) {
                var restangular = AprimaRestangular.get();
                return restangular.one('history/medical-device/patient/' + updateDeviceAttributes.PatientId + '/device/' + updateDeviceAttributes.PatientMedicalDeviceHistoryId).customPUT(updateDeviceAttributes);
            }

            function displayMedicalDeviceHistory(patientId, groupingId) {
                var restangular = AprimaRestangular.get();
                return restangular.one('history/medical-device/patient/' + patientId + '/device/' + groupingId + '/history').get();
            }

            return {
                getMedicalDeviceParseUdi: getMedicalDeviceParseUdi,
                getMedicalDeviceLookup: getMedicalDeviceLookup,
                getMedicalDevices: getMedicalDevices,
                createMedicalDevice: createMedicalDevice,
                updateMedicalDevice: updateMedicalDevice,
                displayMedicalDeviceHistory: displayMedicalDeviceHistory
            };

        }]);